import { createApp } from 'vue'
import App from './App.vue'
import { Lazyload } from 'vant'
import 'vant/lib/index.css'

const app = createApp(App)

// 注册 Vant 懒加载指令
app.use(Lazyload, {
  lazyComponent: true
})

app.mount('#app')
